import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import linkifyHtml from "linkifyjs/html";
import { Link } from "react-router-dom";
import Audio from "react-audioplayer";

import "./Midia.less";

class Midia extends PureComponent {
  static propTypes = {
    iframe: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    idPlaylist: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    imagem: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    descricao: PropTypes.string,
    play: PropTypes.bool,
    style: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      audioPlayerWidth: null,
    };
  }

  render() {
    if (this.props.iframe) {
      return (
        <div
          className="Midia-component"
          id={this.getId()}
          style={this.props.style}
        >
          {this.renderMidia()}
        </div>
      );
    } else if (this.props.play) {
      // Link do vídeo específico
      return (
        <Link
          className="Midia-component"
          id={this.getId()}
          to={`/midia/${this.props.idPlaylist}/${this.props.id}`}
          style={this.props.style}
        >
          {this.renderMidia()}
        </Link>
      );
    } else {
      // Link para o vídeo na lista de vídeos
      return (
        <Link
          className="Midia-component"
          id={this.getId()}
          to={this.props.url}
          style={this.props.style}
          onClick={() => {
            window.midiaFoiClicada = () =>
              setTimeout(() => {
                const midiaClicada = document.getElementById(this.getId());
                if (midiaClicada) {
                  midiaClicada.dispatchEvent(
                    new MouseEvent("click", { bubbles: true })
                  );
                } else {
                  console.log("window.midiaFoiClicada não funcionou");
                }
                delete window.midiaFoiClicada;
              }, 1000);
          }}
        >
          {this.renderMidia()}
        </Link>
      );
    }
  }

  renderMidia() {
    let midia = null;
    if (this.props.iframe) {
      if (this.props.url.includes(".mp3")) {
        // Audio
        midia = (
          <div
            className="audio-player"
            ref={(ref) => {
              if (ref) {
                this.setState({ audioPlayerWidth: ref.offsetWidth });
              }
            }}
          >
            {this.state.audioPlayerWidth && (
              <Audio
                width={this.state.audioPlayerWidth}
                fullPlayer={true}
                autoPlay={false}
                playlist={[
                  {
                    src: this.props.url,
                    img: this.props.imagem,
                  },
                ]}
              />
            )}
          </div>
        );
      } else {
        // Video
        midia = (
          <iframe
            title={this.props.titulo}
            src={this.props.url}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        );
      }
    } else {
      // Cover Art
      midia = (
        <div className="imagem-container">
          <div
            className="imagem"
            style={{ backgroundImage: `url(${this.props.imagem})` }}
          >
            {this.props.play && <div className="play" title="Play" />}
          </div>
        </div>
      );
    }
    return (
      <>
        {midia}
        <span className="titulo">{this.props.titulo}</span>
        {this.props.descricao && (
          <div
            className="descricao"
            dangerouslySetInnerHTML={{
              __html: linkifyHtml(this.props.descricao),
            }}
          />
        )}
      </>
    );
  }

  getId() {
    return `midia-${this.props.id}`;
  }
}

export default Midia;
